import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { createPollData } from 'src/app/data/store/actions/posts.actions';
import { selectCreatePoll } from 'src/app/data/store/selectors/posts.selectors';
import { Buttons, ButtonTextSizes, PollTypes, TextSizes, TextType } from 'src/app/shared/enums';
import { IPoll } from 'src/app/shared/services/posts/posts.type';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TextComponent } from '../../../../../shared/components/text/text.component';
import { IonicModule } from '@ionic/angular';

import { ImageComponent } from '../../../../../shared/components/image/image.component';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { UtilsService } from 'src/app/shared/services/utils.service';

@UntilDestroy()
@Component({
  selector: 'app-create-poll',
  templateUrl: './create-poll.component.html',
  styleUrls: ['./create-poll.component.scss'],
  imports: [
    TextComponent,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ImageComponent,
    ButtonComponent,
  ],
})
export class CreatePollComponent implements OnInit {
  private _fb = inject(FormBuilder);
  private _store = inject(Store);
  private _utils = inject(UtilsService);

  @Input() isMob: boolean | null = false;

  @ViewChild('formOptions') formOptions?: ElementRef<HTMLDivElement>;

  @ViewChild('formContent') formContent?: ElementRef<HTMLDivElement>;

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public readonly Buttons = Buttons;

  public readonly ButtonTextSizes = ButtonTextSizes;

  public readonly pollTypes = PollTypes;

  public readonly minNumOfOptions: number = 2;

  public readonly maxNumOfOptions: number = 10;

  public isForceDismiss = false;

  public poll$: Observable<IPoll | null> = this._store.select(selectCreatePoll);

  public createPollForm: FormGroup = this._fb.group({
    id: [null],
    isMultipleChoices: [false],
    text: [null, [Validators.required]],
    type: [PollTypes.public],
    pollOptions: this._fb.array([
      this._fb.group({
        id: [null],
        text: [null, [Validators.required]],
        sequenceNumber: [0],
      }),
    ]),
  });

  ngOnInit(): void {
    this.poll$.subscribe((poll) => {
      if (poll) {
        this.createPollForm.patchValue({
          id: poll.id,
          isMultipleChoices: poll.isMultipleChoices,
          text: poll.text,
          type: poll.type,
        });

        this.options.removeAt(0);
        poll.pollOptions.forEach((option) => this.options.push(this._fb.group(option)));
      }
    });
  }

  get options() {
    return this.createPollForm.controls['pollOptions'] as FormArray;
  }

  public addOption(num: number) {
    const optionForm = this._fb.group({
      id: [null],
      text: [null, [Validators.required]],
      sequenceNumber: [num],
    });

    this.options.push(optionForm);
  }

  public deleteOption(optionIndex: number) {
    this.options.removeAt(optionIndex);
  }

  public setPollType(event: any) {
    if (event.detail.checked) {
      this.createPollForm.controls['type'].setValue(PollTypes.anonymous);
    } else this.createPollForm.controls['type'].setValue(PollTypes.public);
  }

  public submitForm() {
    if (this.createPollForm.valid && this.options.controls.length >= this.minNumOfOptions) {
      this.isForceDismiss = true;
      this._store.dispatch(createPollData({ poll: this.createPollForm.value }));
      this.close();
    }
  }

  public close() {
    this._utils.dismissModal(this.isForceDismiss);
  }
}
